export const CLEAR_STATE = "CLEAR_STATE";

export const SET_INTERVAL = "SET_INTERVAL";

export const GET_DATA = "GET_DATA";
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS";
export const GET_DATA_FAIL = "GET_DATA_FAIL";